import { t } from '@avalara/bat-apps-shared/i18n';
import { signInURL } from '../../lib/constants';

type Props = {
  href?: string;
  dataRef?: string;
};

const SignInLink = ({ href = signInURL, dataRef = 'offer.login-button' }: Props) => (
  <div className='flex'>
    <h4 className='pad-right-sm'>{t('client.headings.have-an-account')}</h4>
    <a
      href={href}
      title={t('client.accessibility.sign-in-to-your-account')}
      tabIndex={0}
      data-ref={dataRef}
      style={{ color: 'var(--color-blue-darker)' }}
    >
      {t('client.general.sign-in-to-buy')}
    </a>
  </div>
);

export default SignInLink;
